import React from 'react';
import { useSelector } from 'react-redux';

import { hasRight } from '#app/Common/UserCommon';
import ContentViewComponent from '#app/Component/ContentViewComponent';
import IconAction from '#app/Component/IconAction';
import TableComponent from '#app/Component/TableComponent';
import ApiHandler from '#app/Handler/ApiHandler';
import { getRoutePathname } from '#app/Handler/RouteHandler';

function ClosingShopList() {
  const authenticationReducer = useSelector((state) => state.AuthenticationReducer);

  // List Deposits
  const columns = [
    {
      name: 'id',
      label: 'Référence',
      options: { filter: true, sort: true },
    },
    {
      name: 'shop',
      label: 'Boutique',
      options: { filter: true, sort: true },
    },
    {
      name: 'closedAt',
      label: 'Date fermeture',
      options: { filter: true, sort: true },
    },
    {
      name: 'user',
      label: 'Utilisateur',
      options: { filter: true, sort: true },
    },
    {
      name: 'action',
      label: 'Action',
      options: { filter: false, sort: false },
    },
  ];

  const getAction = (row) => {
    if (
      hasRight(authenticationReducer, 'ROLE_SHOP_MANAGEMENT_SHOP') ||
      hasRight(authenticationReducer, 'ROLE_SHOP_MANAGEMENT_SHOP_CLOSING')
    ) {
      return (
        <IconAction
          title="Modifier"
          icon="edit"
          to={getRoutePathname('shop_management_shop_closing', { id: row.id })}
        />
      );
    }
  };

  return (
    <ContentViewComponent breadcrumbs={{ title: 'Liste des clotures de caisse', context: 'Gestion boutique' }}>
      <TableComponent
        id={'api_shop_management_shop_closing_list'}
        title={'Fermetures de caisses'}
        columns={columns}
        promiseData={(resolve) => {
          ApiHandler.get({ route: 'api_shop_management_closing_list' }, (response) => {
            const data = response.data;
            for (const index in data) {
              data[index].action = getAction(data[index]);
              data[index].id = data[index].id ? data[index].id : '-';
              data[index].shop = data[index].shop ? data[index].shop : '-';
              data[index].user = data[index].user ? data[index].user : '-';
            }
            resolve(data);
          });
        }}
      />
    </ContentViewComponent>
  );
}

export default ClosingShopList;
